//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LuckyWheel } from "@lucky-canvas/vue";
import { mapState, mapMutations } from "vuex";
import dayjs from "dayjs";
import { commonApi } from "@/common/index";
export default {
  name: "raffle",
  components: {
    LuckyWheel,
  },
  data() {
    return {
      FAKE_LIST: [
        "12***2 抽中红包金额 58，祝老板多多提款",
        "41***1 抽中红包金额 188，祝老板多多提款",
        "62***8 抽中红包金额 288，祝老板多多提款",
        "12***2 抽中红包金额 88，祝老板多多提款",
        "52***0 抽中红包金额 188，祝老板多多提款",
        "12***2 抽中红包金额 28，祝老板多多提款",
        "21***3 抽中红包金额 388，祝老板多多提款",
        "96***2 抽中红包金额 58，祝老板多多提款",
        "85***8 抽中红包金额 888，祝老板多多提款",
        "43***5 抽中红包金额 28，祝老板多多提款",
        "57***0 抽中红包金额 58，祝老板多多提款",
        "12***2 抽中红包金额 288，祝老板多多提款",
        "59***6 抽中红包金额 388，祝老板多多提款",
        "82***0 抽中红包金额 8，祝老板多多提款",
        "12***2 抽中红包金额 888，祝老板多多提款",
        "15***7 抽中红包金额 58，祝老板多多提款",
        "47***1 抽中红包金额 188，祝老板多多提款",
        "11***8 抽中红包金额 28，祝老板多多提款",
        "20***7 抽中红包金额 288，祝老板多多提款",
        "50***4 抽中红包金额 58，祝老板多多提款",
        "10***7 抽中红包金额 88，祝老板多多提款",
        "17***3 抽中红包金额 28，祝老板多多提款",
        "43***7 抽中红包金额 888，祝老板多多提款",
        "49***2 抽中红包金额 188，祝老板多多提款",
        "XY***76 抽中红包金额 58，祝老板多多提款",
        "A1***3C 抽中红包金额 88，祝老板多多提款",
        "X9***7Z 抽中红包金额 388，祝老板多多提款",
        "P1***3R 抽中红包金额 28，祝老板多多提款",
        "M9***7O 抽中红包金额 288，祝老板多多提款",
        "Z3***1X 抽中红包金额 888，祝老板多多提款",
      ],
      prizes: null,
      blocks: [
        {
          imgs: [
            {
              src: require("../../assets/image/raffle-wheel-bg.png"),
              width: "100%",
              height: "100%",
              rotate: true,
            },
            {
              src: require("../../assets/image/raffle-wheel-border.png"),
              width: "100%",
              height: "100%",
            },
          ],
        },
      ],
      buttons: [
        {
          radius: "2.36rem",

          imgs: [
            {
              src: require("../../assets/image/raffle-wheel-start.png"),
              width: "4.72rem",
              height: "4.72rem",
              top: "-2.36rem",
            },
          ],
        },
      ],
      raffleCount: 0,
      discription: null,
      showRecord: false,
      loadingHistory: false,
      history: [],
      showJackpot: false,
      winPrize: {},
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      isApp: (state) => state.isApp, //是否在app打开
    }),
    getRandomFakeList() {
      return this.FAKE_LIST.sort(() => Math.random() - 0.5);
    },
  },
  mounted() {
    this.getDiscription();
  },
  activated() {
    this.queryRaffleData();
  },
  deactivated() {
    this.showRecord = false;
    this.showJackpot = false;
    this.winPrize = {};
  },
  methods: {
    ...mapMutations(["SET_LOGIN_SHOW"]),
    queryRaffleData() {
      commonApi.DEPOSIT.queryTurntableRaffle()
        .then((result) => {
          const { message, data } = result;
          // 是否关闭活动
          if (data === null) {
            this.$toast({
              message: message,
              icon: "warning",
            });
            return;
          }
          this.raffleCount = data.dzpUnusedCount || 0;
          this.prizes = data.prizeList.map((item) => {
            return {
              ...item,
              fonts: [
                {
                  text: item.prizeName,
                  top: "80%",
                  fontSize: "14xpx",
                  fontWeight: "600",
                  fontColor: "#f64837",
                },
              ],
              imgs: [
                {
                  src: item.appLink,
                  height: "3rem",
                  top: "35%",
                },
              ],
            };
          });
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
        });
    },
    getDiscription() {
      commonApi.HELP.articleById("10001")
        .then((data) => {
          this.discription = data.content;
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
        });
    },
    openRecord() {
      if (!this.isLogin) {
        this.SET_LOGIN_SHOW();
        return;
      }
      this.loadingHistory = true;
      this.showRecord = true;
      commonApi.DEPOSIT.queryHistoryWin({
        activityType: 1,
        pageNo: 1,
        pageSize: 999999,
      })
        .then((data) => {
          const { list } = data.pageInfo;
          this.history = list;
          this.loadingHistory = false;
        })
        .catch((err) => {
          this.history = [];
          this.loadingHistory = false;
        });
    },
    closeJackpot() {
      this.showJackpot = false;
    },
    startCallback() {
      if (!this.isLogin) {
        this.SET_LOGIN_SHOW();
        return;
      }
      const loadingToast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });

      commonApi.DEPOSIT.raffle()
        .then((res) => {
          const { data, message } = res;
          loadingToast.clear();
          if (!data) {
            this.$toast({
              message,
              icon: "warning",
            });
            return;
          }

          this.raffleCount = Math.max(0, this.raffleCount - 1);
          this.$refs.myLucky.play();
          this.winPrize = data;
          console.log(data);
          setTimeout(() => {
            // 调用stop停止旋转并传递中奖索引
            const prizeIndex = this.prizes.findIndex(
              (item) => item.prizeName === data.prizeName
            );
            this.$refs.myLucky.stop(prizeIndex);
          }, 3000);
        })
        .catch((err) => {
          this.$toast({
            message: err || err.message,
            icon: "warning",
          });
        });
    },

    endCallback() {
      this.showJackpot = true;
    },

    handleBack() {
      if (window.history.length < 2) {
        this.$router.push("/");
        return;
      }
      this.$router.go(-1);
    },

    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/raffle/index.vue